import { render, staticRenderFns } from "./AlertPopUp.vue?vue&type=template&id=8df48994&"
import script from "./AlertPopUp.vue?vue&type=script&lang=js&"
export * from "./AlertPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AlertPopUp.vue?vue&type=style&index=0&id=8df48994&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports